











import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { Wallet } from '@/store/wallet/types';
import { User } from '@/store/profile/types';
import { BankAccount, MangoPayMandates } from '@/store/mangoPay/types';
import WithdrawWallet from '@/components/wallet/WithdrawWallet.vue';

@Component({
  name: 'Withdraw-wallet-view',
  components: {
    WithdrawWallet,
  },
})
export default class WithdrawWalletView extends Vue {
  @Getter('wallet/wallet') wallet?: Wallet;
  @Getter('profile/user') user?: User;

  @Getter('mangoPay/bankAccounts') bankAccounts?: Array<BankAccount>;
  @Getter('mangoPay/mandates') mandates: MangoPayMandates;
}
